import { z } from 'zod';

export const UpdateReferralSettingsInputSchema = z.object({
  referrerCreditAmountInSmallestUnit: z.number().int().min(0),
  refereeCreditAmountInSmallestUnit: z.number().int().min(0),
  currency: z.string().trim().length(3).default('CZK'),
});

export const ListAdminReferralsQuerySchema = z.object({
  status: z.enum(['PENDING', 'ACTIVATED', 'PAID_OUT']).optional(),
  q: z.string().max(200).optional(),
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export type UpdateReferralSettingsInput = z.infer<typeof UpdateReferralSettingsInputSchema>;
export type ListAdminReferralsQuery = z.infer<typeof ListAdminReferralsQuerySchema>;
